export function formatTimestamp(inputTimestamp, translate) {
  const currentDate = new Date().setHours(0, 0, 0, 0);

  const inputDatetime = new Date(inputTimestamp);
  inputDatetime.setHours(0, 0, 0, 0);

  if (inputDatetime.getTime() === currentDate) {
    return translate('today');
  }

  const yesterdayDatetime = new Date(currentDate);
  yesterdayDatetime.setDate(yesterdayDatetime.getDate() - 1);
  if (inputDatetime.getTime() === yesterdayDatetime.getTime()) {
    return translate('yesterday');
  }

  return inputDatetime.toLocaleDateString('en-GB');
}